import React from 'react'
import { List, ListItem, Typography } from '@mui/material'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import { IZwaveDeviceBackend } from '@app/@types/scenes/scenesDevices'
import useStyles from './Room.style'
import Device from '../DevicesList/Device'

interface Props {
  name: string,
  devices: Array<IZwaveDeviceBackend>,
  deviceType: string,
}

const Room: React.FC<Props> = (props) => {
  const {
    name,
    devices,
    deviceType,
  } = props

  const { classes } = useStyles()

  const wallmoteFilteredDevices = devices.filter((device) => device.wallmote === false)
  return (
    <Wrapper>
      <Typography className={classes.title}>{name}</Typography>
      <List className={classes.devicesWrapper}>
        {wallmoteFilteredDevices.length
          ? wallmoteFilteredDevices.map((device) => (
            <ListItem className={classes.listItem} key={device.id}>
              <Device
                device={device}
                deviceType={deviceType}
              />
            </ListItem>
          )) : <Typography className={classes.empty} align="center">NO DEVICES</Typography>}
      </List>
    </Wrapper>
  )
}

export default Room
